if (!customElements.get('section-video-switch')) {
    customElements.define('section-video-switch', class SectionVideoSwitch extends HTMLElement {
        constructor() {
            super()
            this.items = Array.from(this.querySelectorAll('.section-video-switch-text-item'))
            this.lastScrollTop = 0
            this.initBrowserWidth = this.getBrowserWidth()
            this.swiperVideo = this.querySelector('#component-switch--video')
            this.init()
        }

        init() {
            this.items.forEach((ele, index) => {
                ele.addEventListener('click', () => {
                    this.activeItem(ele, index)
                })
            })
            const swiperContainer = this.querySelector('#component-switch--content')
            swiperContainer.swiper.on("slideChange", (e) => {
                if (this.getBrowserWidth() > 999) {
                    this.activeItem(this.items[e.activeIndex], e.activeIndex)
                }
                this.swiperVideo.slideTo(e.activeIndex)
            })
            this.swiperVideo.swiper.on("slideChange", (e) => {
                swiperContainer.slideTo(e.activeIndex)
            })
            window.addEventListener("resize", window._debounce(() => {
                if (this.getBrowserWidth() <= 999) {
                    this.switchVideo(0)
                }
            }, 400))
        }


        isScrollTop() {
            const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
            let is_top = currentScrollTop > this.lastScrollTop
            this.lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // 对滚动位置进行限制，防止负值
            return is_top
        }

        activeItem(ele, index) {
            if (this.getBrowserWidth() <= 999) return
            $(this.items).not(ele).removeClass('active')
            $(this.items).not(ele).children('._text_').slideUp()
            $(ele.querySelector('._text_')).slideDown()
            ele.classList.add('active')
            this.switchVideo(index)
        }

        getBrowserWidth() {
            return (
                window.innerWidth ||
                document.documentElement.clientWidth ||
                document.body.clientWidth
            );
        }
        switchVideo(index) {
            this.swiperVideo.slideTo(index)
        }

        getIntersectionObserver() {
            return new IntersectionObserver(function (
                entries,
                observer
            ) {
                entries.forEach((entry) => {
                    // if (entry.isIntersecting) {
                    //     // let ele = entry.target;
                    //     entry.target.classList.add('active')
                    // } else {
                    //     entry.target.classList.remove('active')
                    // }
                });
            });
        }
    })
}

